import { Pipe, PipeTransform } from "@angular/core";
import { isEmpty } from 'lodash';
@Pipe({ name: 'highlight' })
export class HighlightPipe implements PipeTransform {

  constructor() {
  }
  transform(text: string, toHighlight: string) {
    if (!isEmpty(text) && !isEmpty(toHighlight)) {
      let terms = toHighlight.trim().split(" ");
      terms.sort(function (a, b) {
        return b.length - a.length;
      });

      terms.forEach(term => {
        let pos = 0;
        let debut = 0;
        // lower case and normalize
        const rechercheNormalisee = term.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase();
        const outputNormalise = text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase();

        let highlightedOutput = '';
        while (pos !== -1) {
          pos = outputNormalise.indexOf(rechercheNormalisee, debut);
          if (pos !== -1) {
            highlightedOutput += text.slice(debut, pos) +
              '#@!' + text.slice(pos, pos + term.length) + '#/@!';
            debut = pos + rechercheNormalisee.length;
          }
        }
        highlightedOutput += text.slice(debut);
        text = highlightedOutput;
      });

    }
    text = text.split("#@!").join('<span class="highlightedText">');
    text = text.split("#/@!").join('</span>');
    return text;
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-common-module/src/pipe/highlight.pipe.ts